import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Spinner } from 'components';

import {
  FinderColumn,
  ColumnList,
  ColumnItem,
  ColumnItemName,
  ColumnItemArrow,
} from 'apps/finder/styles';

@observer
export class ProjectsColumn extends React.Component {
  render() {
    const { manager } = this.props;
    const { projects, SetInput, input, projectsQueryLoading } = manager;
    return (
      <FinderColumn>
        {projectsQueryLoading ? (
          <Spinner margin='30px auto' />
        ) : (
          <ColumnList>
            {projects.map(item => {
              const displayName = `${item.spacePath}/${item.slug}`;
              const pathSegs = input.split('/');
              const selected = `${pathSegs[0]}/${pathSegs[1]}` === displayName;
              const active =
                input.substring(0, input.length - 1) === displayName;
              return (
                <ColumnItem
                  key={item.id}
                  onClick={() => SetInput(`${item.spacePath}/${item.slug}/`)}
                  selected={selected}
                  active={active}
                >
                  <ColumnItemName>{displayName}</ColumnItemName>
                  <ColumnItemArrow active={active}>&#8250;</ColumnItemArrow>
                </ColumnItem>
              );
            })}
          </ColumnList>
        )}
      </FinderColumn>
    );
  }
}

ProjectsColumn.propTypes = {
  manager: PropTypes.object,
};
